module.exports = __webpack_public_path__ + "static/img/开开服饰.053613b3.png";